module.exports = __webpack_public_path__ + "img/contract.9c3d393f.svg";